import type { NestedI18nObject } from '../../utils';

const searchTable: NestedI18nObject = {
  // Search Table Pages
  createForm: {
    newRule: 'New Rule',
  },
  updateForm: {
    ruleConfig: 'Rule configuration',
    basicConfig: 'Basic Information',
    ruleName: {
      nameLabel: 'Rule Name',
      nameRules: 'Please enter the rule name!',
    },
    ruleDesc: {
      descLabel: 'Rule Description',
      descPlaceholder: 'Please enter at least five characters',
      descRules: 'Please enter a rule description of at least five characters!',
    },
    ruleProps: {
      title: 'Configure Properties',
      templateLabel: 'Rule Template',
      typeLabel: 'Rule Type',
    },
    object: 'Monitoring Object',
    schedulingPeriod: {
      title: 'Set Scheduling Period',
      timeLabel: 'Starting Time',
      timeRules: 'Please choose a start time!',
    },
  },
  titleDesc: 'Description',
  ruleName: 'Rule name is required',
  titleCallNo: 'Number of Service Calls',
  titleStatus: 'Status',
  nameStatus: {
    default: 'default',
    running: 'running',
    online: 'online',
    abnormal: 'abnormal',
  },
  titleUpdatedAt: 'Last Scheduled at',
  exception: 'Please enter the reason for the exception!',
  titleOption: 'Option',
  config: 'Configuration',
  subscribeAlert: 'Subscribe to alerts',
  title: 'Enquiry Form',
  new: 'New',
  chosen: 'chosen',
  item: 'item',
  totalServiceCalls: 'Total Number of Service Calls',
  tenThousand: '0000',
  batchDeletion: 'batch deletion',
  batchApproval: 'batch approval',
};

export default searchTable;
